import { render, staticRenderFns } from "./stocktransfercreateform.vue?vue&type=template&id=38331411"
import script from "./stocktransfercreateform.vue?vue&type=script&lang=js"
export * from "./stocktransfercreateform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports